////////LIBRARY/////////
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, kioskPerimeterActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getPerimeters = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_PERIMETERS(user)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)
		yield put(kioskPerimeterActionCreators.getPerimetersSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskPerimeterActionCreators.getPerimetersFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getPerimeter = function* ({ payload }) {
	const idPerimeter = payload.idPerimeter
	const user = yield select(selectIdsUser)
	user['idPerimeter'] = idPerimeter
	const apiCall = R.GET_PERIMETER(user)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskPerimeterActionCreators.getPerimeterSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskPerimeterActionCreators.getPerimeterFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getKiosksWithCriteria = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSKS_WITH_CRITERIA(user)
	yield put(globalLoadingActionCreators.startLoading())

	let dataFormat = payload.datas
	dataFormat.isStatic = payload.mode === 'dynamic' ? false : true

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataFormat)
		yield put(kioskPerimeterActionCreators.getKiosksWithCriteriaSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskPerimeterActionCreators.getKiosksWithCriteriaFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getListTags = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_TAGS_PERIMETER(user)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)
		yield put(kioskPerimeterActionCreators.getListTagsSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskPerimeterActionCreators.getListTagsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createPerimeter = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_PERIMETER(user)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.perimeter)

		// Prepare data to be added on current list
		let item = cloneDeep(data.data)

		yield put(kioskPerimeterActionCreators.createPerimeterSuccess(item))

		yield put(toastSuccessActionCreators.hydrateToast('toast__kioskScope__admin__create'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskPerimeterActionCreators.createPerimeterFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updatePerimeter = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	user['idPerimeter'] = payload.idPerimeter
	const apiCall = R.UPDATE_PERIMETER(user)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.perimeter)

		// Prepare data to be added on current list
		let item = cloneDeep(data.data)

		yield put(kioskPerimeterActionCreators.updatePerimeterSuccess(item))

		/*   const modal = {
            level: 'validation',
            title: 'modal__kioskScope__admin__title__updateScope',
            key: 'modal__kioskScope__admin__content__updateScope',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		//yield put( modalsActionCreators.hydrateModal(modal));

		yield put(toastSuccessActionCreators.hydrateToast('toast__kioskScope__admin__update'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskPerimeterActionCreators.updatePerimeterFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const deletePerimeter = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	user['idPerimeter'] = payload.idPerimeter
	let apiCall

	yield put(globalLoadingActionCreators.startLoading())

	apiCall = R.DELETE_PERIMETER(user)

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(kioskPerimeterActionCreators.deletePerimeterSuccess(payload.idPerimeter))

		/* const modal = {
            level: 'validation',
            title: 'modal__kioskScope__admin__title__deleteScope',
            key: 'modal__kioskScope__admin__content__deleteScope',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		yield put(toastSuccessActionCreators.hydrateToast('toast__kioskScope__admin__delete'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskPerimeterActionCreators.deletePerimeterFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_PERIMETERS, getPerimeters)
	yield takeLatest(ActionsTypes.GET_PERIMETER, getPerimeter)
	yield takeLatest(ActionsTypes.GET_KIOSKS_WITH_CRITERIA, getKiosksWithCriteria)
	yield takeLatest(ActionsTypes.GET_LIST_TAGS, getListTags)
	yield takeLatest(ActionsTypes.CREATE_PERIMETER, createPerimeter)
	yield takeLatest(ActionsTypes.UPDATE_PERIMETER, updatePerimeter)
	yield takeLatest(ActionsTypes.DELETE_PERIMETER, deletePerimeter)
}

export default sagas
